

import { ButtonLink } from "@/components/button-link";

export function NotFoundRoute() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
      <p className="text-muted-foreground text-6xl font-semibold">404</p>
      <div className="space-y-1">
        <h1 className="text-xl font-semibold">Page not found</h1>
        <p className="text-muted-foreground text-sm">
          That link may be out of date.
        </p>
      </div>
      <ButtonLink variant="outline" to="/challenges">
        Back to challenges
      </ButtonLink>
    </div>
  );
}
